import { render, staticRenderFns } from "./Neo4J.vue?vue&type=template&id=90cd7f0a&scoped=true&"
import script from "./Neo4J.vue?vue&type=script&lang=js&"
export * from "./Neo4J.vue?vue&type=script&lang=js&"
import style0 from "./Neo4J.vue?vue&type=style&index=0&id=90cd7f0a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cd7f0a",
  null
  
)

export default component.exports